import React, { useEffect, useRef, useState } from "react";
import { Form, Modal, Spinner, Table } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "./LoanDocumentFetch.scss";
import ErrorHandler from "../ErrorHandler/ErrorHandler";
import { post } from "../../utils/DeApi";
import { useToggle } from "../../hooks";
import moment from "moment";

const LoanDocumentFetch = ({ onClose, show = false, onElasticState, filedAt=null }) => {
  const [cik, setCik] = useState("");
  const [filingDate, setFilingDate] = useState(filedAt);
  const [docMap, setDocMap] = useState([]);
  const [error, setError] = useState(null);
  const [isSubmitting, toggleIsSubmitting] = useState(false);
  /* *** confirmation modal assets *** */
  const [visible, setVisible] = useState(false);
  const subscribedPromises = useRef([]);

  useEffect(() => {
    /* *** unsubscribing all promises *** */
    const subscriptions = subscribedPromises.current;
    return () => subscriptions.forEach((promise) => promise.cancel());
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    toggleIsSubmitting(true);
    const refetchDocPromise = post("refetch/loan/filings", {
      cik: cik,
      filedAt: filingDate,
    });

    Promise.resolve(refetchDocPromise.promise)
      .then((response) => {
        if (response.success) {
          
          let data = response.data;
          setDocMap(Object.values(data?.docMap));
          onClose( false);
          setTimeout(()=> {
            onElasticState(data.ElasticSearch);
            setVisible(true);
          }, 1000);
        }
        toggleIsSubmitting();
      })
      .catch((error) => {
        console.log("ERROR: ", error)
        setError(error);
      })
      .finally(toggleIsSubmitting(true));
    subscribedPromises.current.push(refetchDocPromise);
  };

  /* *** parent modal closing function which takes input ciks *** */
  const _handleModalClose = (val) => {
    
    setError(null);
    toggleIsSubmitting(val);
    onClose(val);
  };

  /* *** closing function for confirmation modal *** */
  const _handleCloseConfirmationModal = () => {
    setVisible(false);
    setDocMap([]);
    setCik("");
  };

  const DetailShowModal = () => {
    return (
      <Modal
        show={visible}
        onHide={_handleCloseConfirmationModal}
        animation={false}
        backdrop={"static"}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Updated Loan Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-md-12">
              <div className="col-md-12">
                <h3>CIK# {cik}</h3>
                 <p className="text-danger">Filings has been updated on Elastic Index and S3 Instances.</p>
              </div>
            
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <React.Fragment>
      <Modal
        show={show}
        onHide={() => _handleModalClose(false)}
        animation={false}
        backdrop={"static"}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Refetch Loan Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicCik">
              <Form.Label>CIK#</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document cik"
                value={cik}
                onChange={(e) => setCik(e.target.value.trim())}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicFilingDate">
              <Form.Label>Filing Date</Form.Label>
              <Form.Control
                type="date"
                placeholder="Filing Date"
                value={moment(filingDate).format('YYYY-MM-DD')}
                onChange={(e) => {
                  setFilingDate(e.target.value.trim());
                }}
              />
            </Form.Group>
            <Button
              type="submit"
              className="float-right btn btn-success"
              disabled={isSubmitting}
            >
              {isSubmitting && (
                <Spinner
                  as="span"
                  animation="border"
                  variant="light"
                  size="sm"
                  className="m-1"
                />
              )}
              {"Re-Fetch Document"}
            </Button>
          </Form>
          {error && <ErrorHandler error={error} message={error?.data?.message} />}
        </Modal.Body>
      </Modal>
      {visible && <DetailShowModal />}
    </React.Fragment>
  );
};

export default LoanDocumentFetch;
